// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageRequestDeclineBody = {
  chatId: string;
};

export type typeMessageRequestDeclineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isDeclined: boolean };
};

export type typeMessageRequestDeclineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageRequestDeclineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageRequestDeclineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageRequestDeclineBody = {
  type: "object",
  properties: { chatId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageRequestDecline(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageRequestDeclineBody);
  }

  return async function postMessageRequestDecline(
    payload: typeMessageRequestDeclineBody,
  ): Promise<
    typeMessageRequestDeclineOutput200 | typeMessageRequestDeclineOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageRequestDecline" failed before calling the network. #5b6c2bd5f162`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5b6c2bd5f162" },
        },
        data: null,
      } as typeMessageRequestDeclineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message-request/decline`,
      httpMethod: "POST",
      options,
    })) as
      typeMessageRequestDeclineOutput200 | typeMessageRequestDeclineOutput400;
  };
}
